module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/img_app-584671c6b0997d3365c08f79c3d43863.png";